export default __webpack_public_path__ + "static/media/photo8.28a39512.jpeg";